import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StorageService } from 'src/app/core/services/storage.service';
import { PopupRoleSkillDetailsComponent } from '@shared/components/day-program-recap/popup-role-skill-details/popup-role-skill-details.component';
import { Motif } from '@shared/models/motif.model';
import { DefaultPopupComponent } from '../components/default-popup/default-popup.component';
import { CONFIRMATION_MESSAGE, CONFIRMATION_MESSAGE_VALIDATE } from '../const/globals.const';

@Injectable({
  providedIn: 'root',
})
export class PopupManagerService {
  constructor(
    private matDialog: MatDialog,
    private storageService: StorageService
  ) {}

  openPopupByType(
    popupTitle: string,
    popupDescription: string,
    buttonsArray: any,
    popupWidth: number,
    popupType: string,
    motifs?: Motif[],
    preSelectedMotif?: Motif | null,
    closeDelete?: boolean
  ) {
    const tmp = popupWidth ? (popupWidth < 320 ? 320 : popupWidth > 640 ? 640 : popupWidth) : 320;

    return this.matDialog.open(DefaultPopupComponent, {
      width: tmp.toString() + 'px',
      data: {
        title: popupTitle,
        description: popupDescription,
        type: popupType ? popupType : 'close',
        buttons: buttonsArray,
        motifs: motifs ?? null,
        selectedMotif: preSelectedMotif ?? null,
        closeDelete: closeDelete,
      },
    });
  }

  openConfirmationEditVacationPopup(
    title: string,
    description: string,
    width: number,
    colorType: string[],
    textButton: string[]
  ) {
    const buttons = [{ value: 0, name: 'Annuler', type: 'text', color: 'primary' }];

    for (let index = 0; index < colorType.length; index++) {
      buttons.push({ value: index + 1, name: textButton[index], type: 'primary', color: colorType[index] });
    }
    return this.openPopupByType(title, description, buttons, width, 'default');
  }

  openConfirmationPopup(
    title: string,
    description: string,
    width: number,
    colorType: string,
    textButton: string,
    motifs?: Motif[],
    preSelectedMotif?: Motif | null,
    closeDelete?: boolean
  ) {
    const buttons = [
      { value: false, name: 'Annuler', type: 'text', color: 'primary' },
      { value: true, name: textButton, type: 'primary', color: colorType },
    ];
    return this.openPopupByType(title, description, buttons, width, 'default', motifs, preSelectedMotif, closeDelete);
  }

  openConfirmationPopupWithStringMotif(
    title: string,
    description: string,
    width: number,
    colorType: string,
    textButton: string,
    motifs?: Motif[],
    preSelectedMotif?: string
  ) {
    const buttons = [
      { value: false, name: 'Annuler', type: 'text', color: 'primary' },
      { value: true, name: textButton, type: 'primary', color: colorType },
    ];
    const tmp = width ? (width < 320 ? 320 : width > 640 ? 640 : width) : 320;

    return this.matDialog.open(DefaultPopupComponent, {
      width: tmp.toString() + 'px',
      data: {
        title,
        description,
        type: 'default',
        buttons,
        motifs: motifs ?? null,
        selectedMotif: preSelectedMotif ?? null,
      },
    });
  }

  openUnsavedChangesPopup(isHome: boolean) {
    const title = `${isHome ? 'Valider' : 'Sauvegarder'} les modifications ?`;
    const description = isHome ? CONFIRMATION_MESSAGE_VALIDATE : CONFIRMATION_MESSAGE;

    const isDisconnecting = this.storageService.getData('isDisconnecting');

    let buttons = [];

    if (isDisconnecting) {
      buttons = [
        { value: 'continue', name: isHome ? 'Ne pas valider' : 'Ne pas sauvegarder', type: 'text', color: 'danger' },
        { value: 'save', name: isHome ? 'Valider' : 'Sauvegarder', type: 'primary', color: 'primary' },
      ];
    } else {
      buttons = [
        { value: 'continue', name: isHome ? 'Ne pas valider' : 'Ne pas sauvegarder', type: 'text', color: 'danger' },
        { value: 'cancel', name: 'Annuler', type: 'lite', color: 'primary' },
        { value: 'save', name: isHome ? 'Valider' : 'Sauvegarder', type: 'primary', color: 'primary' },
      ];
    }
    return this.openPopupByType(title, description, buttons, 520, 'default');
  }

  openUnsavedCommentPopup(isHome: boolean) {
    const title = `${isHome ? 'Valider' : 'Sauvegarder'} les modifications ?`;
    const description = "N'oubliez pas de sauvegarder votre commentaire";

    const isDisconnecting = this.storageService.getData('isDisconnecting');

    let buttons = [];

    if (isDisconnecting) {
      buttons = [
        { value: 'continue', name: isHome ? 'Ne pas valider' : 'Ne pas sauvegarder', type: 'text', color: 'danger' },
        { value: 'save', name: isHome ? 'Valider' : 'Sauvegarder', type: 'primary', color: 'primary' },
      ];
    } else {
      buttons = [
        { value: 'continue', name: isHome ? 'Ne pas valider' : 'Ne pas sauvegarder', type: 'text', color: 'danger' },
        { value: 'cancel', name: 'Annuler', type: 'lite', color: 'primary' },
        { value: 'save', name: isHome ? 'Valider' : 'Sauvegarder', type: 'primary', color: 'primary' },
      ];
    }
    return this.openPopupByType(title, description, buttons, 520, 'default');
  }

  openInfoPopup(title: string, description: string, width: number) {
    return this.openPopupByType(title, description, null, width, 'close');
  }

  openRoleSkillDetailsPopup(data: any) {
    return this.matDialog.open(PopupRoleSkillDetailsComponent, {
      data,
    });
  }
}
